import React from "react";
import classnames from "classnames";

const PreviewSection = (props) => {
  const { headerText, basicText, image, reverse } = props;

  const classNames = classnames({
    "verification-landing_preview-feature": true,
    "is-reverse": reverse,
  });

  return (
    <div className={classNames}>
      <div className="preview-desc">
        <div className="preview-header">{headerText}</div>
        <div className="preview-text">{basicText}</div>
      </div>
      <img src={image} />
    </div>
  );
};

const PerformanceAnalysisLandingPreview = (props) => {
  const previews = [
    {
      headerText: "CHAMPION BREAKDOWN",
      basicText: "We broke down how you played your top three champions across both Summoner’s Rift and Howling Abyss.",
      image: "https://static.bigbrain.gg/assets/lol/performance_analysis/images/yir_preview_stats.png",
    },
    {
      headerText: "OVERALL STATS",
      basicText:
        "A bird’s eye view of all the champions you played this past year — including your highest highs and lowest lows.",
      image: "https://static.bigbrain.gg/assets/lol/performance_analysis/images/yir_preview_champion_breakdown.png",
      reverse: true,
    },
    {
      headerText: "POSITION ANALYSIS",
      basicText: "See your top two most played positions and compare yourself with other players.",
      image: "https://static.bigbrain.gg/assets/lol/performance_analysis/images/yir_preview_position.png",
    },
  ];

  return (
    <div className="verification-landing_preview">
      {previews.map((preview, index) => {
        return <PreviewSection key={index} {...preview} />;
      })}
    </div>
  );
};

export default PerformanceAnalysisLandingPreview;
